import React, { useState, useEffect } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import CardData from "../components/CardData";
import CardList from "../components/CardList";
import ThermoGuage from "../components/ThermoGuage";
import FuelGuage from "../components/FuelGuage";
import GuageChart from "../components/GuageChart";
import Navbar from "../components/Navbar";
import LineChart from "../components/LineChart";
import Loader from "../components/Loader";
import Warning from "../components/Warning";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "../components/Map.css";
import WarningAlert from "../components/WarningAlert";
import Products from "../data/gensetData";
import CardListStatus from "../components/CardListStatus";
import { io } from "socket.io-client";
import { fireWarning } from "../actions/productActions";
const URL =
  process.env.NODE_ENV === "production" ? '' : "http://localhost:3001";
console.log("URL", URL);
const socket = io(URL);
// const socket = openSocket("https://vidyutrakshak-mi.herokuapp.com:5001");

console.log("socket", socket);
// Total - 23, Temp -2, Speed -4,
const ProductScreen = ({ match, history }) => {
  const [product, setProduct] = useState({});
  const [popCount, setPopProduct] = useState(0);
  const dispatch = useDispatch();
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  function sendSocketIO() {
    socket.emit("register", match.params.id);
  }
  function getProduct() {
    socket.on("get-gen", (data) => {
      setProduct(data);
    });
  }
  function getProductData() {
    socket.emit("readData", match.params.id);
    socket.on("get-gen", (data) => {
      // console.log("SOCKET DATA2", data);
      setProduct(data);
    });
  }

  useEffect(() => {
    function onConnect() {
      console.log("connected successfully", socket.id);
    }
    function onDisconnect() {
      console.log("Disconnected successfully", socket.id);
    }
    function disconnectUser() {
      socket.emit("disconnect"); // Custom event to notify the server
    }
    if (match.params.id) {
      socket.on("connect", onConnect);
      sendSocketIO();
      // getProduct();
      socket.on("disconnect", onDisconnect);
      document.addEventListener("beforeunload", disconnectUser);
    }
    // if (match.params.id) {
    //   getProductData();
    // }
    setInterval(() => {
      if (match.params.id) {
        getProduct();
        // getProductData();
      }
    }, 3000);
    return () => {
      document.removeEventListener("beforeunload", disconnectUser);
      if (socket) {
        socket.off("connect", onConnect);
        socket.off("disconnect", onDisconnect);
      }
    };
  }, [socket, match.params.id]);

  useEffect(() => {
    if (!userInfo) {
      history.push("/login");
    } else {
      const fetchProduct = async () => {
        const config = {
          headers: {
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
    
        const { data } = await axios.get(URL + `/api/products/${match.params.id}`, config);
        setProduct(data);
        // console.log(data);
        if (product.engineSpeedRPM.length > 10) {
          console.log("*****************Inside 10*****************");
          const res = await axios.post(URL + `/api/products/pop/${match.params.id}`, config);
        }
        console.log(product);
      };
      setTimeout(() => {
        if (popCount < 10) {
          setPopProduct(popCount + 1);
          // console.log(popCount);
        } else {
          setPopProduct(0);
          // console.log(popCount);
        }
      }, 3000);
      if (product) {
        fetchProduct();
      }
    }
  }, [match, popCount]);

  // useEffect(() => {
  //   if (!userInfo) {
  //     history.push("/login");
  //   } else {
  //     const fetchProduct = async () => {
  //       const { data } = await axios.get(`/api/products/${match.params.id}`);
  //       setProduct(data);
  //       console.log(data);
  //       if (data.engineSpeedRPM.length > 10) {
  //         const res = await axios.post(`/api/products/pop/${match.params.id}`);
  //       }
  //       // Offline Access - Imported Data
  //       // const product = Products.find(
  //       //   (product) => product._id == match.params.id
  //       // );
  //       // setProduct(product);
  //       console.log(product);
  //     };
  //     setTimeout(() => {
  //       if (popCount < 10) {
  //         setPopProduct(popCount + 1);
  //         console.log(popCount);
  //       } else {
  //         setPopProduct(0);
  //         console.log(popCount);
  //       }
  //     }, 5000);
  //     fetchProduct();
  //   }
  // }, [match, popCount]);

  return (
    <>
      <Navbar />
      <br />
      <br />
      <br />
      {!product ? (
        <Loader />
      ) : (
        <div className="tw-font-nunito">
          <br />
          <br />
          {/* <h1 className="tw-text-center">Generator ID #{product._id}</h1> */}
          <h1 className="tw-font-nunito sm:tw-text-3xl tw-text-2xl tw-font-bold tw-text-center">
            Generator Number #{product.gensetNumber} <sup>({product.isConnected ? 'Connected' : 'Not Connected'})</sup>
          </h1>
          <br />
          <div className="tw-flex tw-flex-row tw-justify-evenly tw-flex-wrap">
            {product.voltage && product.current && (
              <>
                <CardList
                  title="Generator ON/OFF"
                  product={product}
                  // unit="V"                colour="black"
                  bgColour="white"
                  icon="fa fa-power-off"
                />
                <CardListStatus
                  title="Generator Status"
                  product={product}
                  // unit="V"                colour="black"
                  bgColour={'white'}
                  icon="fas fa-heartbeat"
                />
                {/* <CardList
                  title="Running Hours"
                  reading={
                    product.totalRunningHours[
                      product.totalRunningHours.length - 1
                    ]
                  }
                  // unit="Hr"
                  colour="black"
                  bgColour="white"
                  icon="fas fa-clock"
                /> */}
                <CardList
                  title="Service Due Date"
                  reading={new Date(product.servicedueDate).toDateString()}
                  // unit="Hr"
                  colour="black"
                  bgColour="white"
                  icon="fas fa-calendar"
                />
            
                {/* {console.log(
                  product.lastUpdated[product.lastUpdated.length - 1]
                )}

                {console.log(
                  "LocalTime",
                  new Date(
                    Date.parse(`
                      ${
                        product.lastUpdated[product.lastUpdated.length - 1]
                      } UTC`)
                  ).toLocaleString()
                )} */}
                {product.lastUpdated && (
                  <CardList
                    title="Last Updated"
                    readingDate={new Date(
                      Date.parse(`
                          ${
                            product.lastUpdated[product.lastUpdated.length - 1]
                          } UTC`)
                    ).toLocaleString()}
                    // reading={product.updatedAt}
                    // unit="V"
                    colour="black"
                    bgColour="white"
                    icon="fas fa-hourglass-half"
                  />
                )}
                <CardList
                  title="Running Hours"
                  reading={product.runningLeftTime ? product.runningLeftTime.toFixed(2) : 0}
                  // unit="Hr"
                  colour="black"
                  bgColour="white"
                  icon="fas fa-clock"
                />
              </>
            )}
          </div>
          <br />
          <br />
          <p className="sm:tw-text-3xl tw-text-2xl tw-font-bold tw-text-center">
            Genset Alarm Info
          </p>
          <br />
          {product.voltage && product.current && (
            <div className="tw-flex tw-flex-row tw-justify-evenly tw-flex-wrap">
              <>
                <WarningAlert
                  value={product.voltage[product.voltage.length - 1].vR}
                  title={"voltage"}
                  minValue={product.voltageOffset.min}
                  maxValue={product.voltageOffset.max}
                  showMin={true}
                  showMax={true}
                  otherValues={product.voltage[product.voltage.length - 1]}
                />
                <WarningAlert
                  value={product.current[product.current.length - 1].iR}
                  title={"current"}
                  minValue={product.currentOffset.min}
                  maxValue={product.currentOffset.max}
                  showMin={false}
                  showMax={true}
                  otherValues={product.current[product.current.length - 1]}
                />
                <WarningAlert
                  value={product.frequency[product.frequency.length - 1]}
                  title={"frequency"}
                  minValue={product.frequencyOffset.min}
                  maxValue={product.frequencyOffset.max}
                  showMin={true}
                  showMax={true}
                />
                <WarningAlert
                  value={
                    product.batteryVoltage[product.batteryVoltage.length - 1]
                  }
                  title={"batteryVoltage"}
                  minValue={product.batteryVoltageOffset.min}
                  maxValue={product.batteryVoltageOffset.max}
                  showMin={true}
                  showMax={false}
                />
                <WarningAlert
                  value={product.fuelLevel[product.fuelLevel.length - 1]}
                  title={"fuelLevel"}
                  minValue={product.fuelLevelOffset.min}
                  maxValue={product.fuelLevelOffset.max}
                  showMin={true}
                  showMax={false}
                />
                {/* <WarningAlert
                  value={
                    product.engineSpeedRPM[product.engineSpeedRPM.length - 1]
                  }
                  title={"engineSpeedRPM"}
                  minValue={product.engineSpeedRPMOffset.min}
                  maxValue={product.engineSpeedRPMOffset.max}
                /> */}
                {/* <WarningAlert
                  value={
                    product.engineOilPressure[
                      product.engineOilPressure.length - 1
                    ]
                  }
                  title={"engineOilPressure"}
                  minValue={product.engineOilPressureOffset.min}
                  maxValue={product.engineOilPressureOffset.max}
                /> */}
                <WarningAlert
                  value={
                    product.engineCoolantTemp[
                      product.engineCoolantTemp.length - 1
                    ]
                  }
                  title={"engineCoolantTemp"}
                  minValue={product.engineCoolantTempOffset.min}
                  maxValue={product.engineCoolantTempOffset.max}
                  showMin={false}
                  showMax={true}
                />
                {/* <WarningAlert
                  value={product.oilTemp[product.oilTemp.length - 1]}
                  title={"oilTemp"}
                  minValue={product.oilTempOffset.min}
                  maxValue={product.oilTempOffset.max}
                /> */}
                <WarningAlert
                  value={product.powerFactor[product.powerFactor.length - 1]}
                  title={"powerFactor"}
                  minValue={product.powerFactorOffset.min}
                  maxValue={product.powerFactorOffset.max}
                  showMin={true}
                  showMax={false}
                />
                <WarningAlert
                  value={product.powerKW[product.powerKW.length - 1]}
                  title={"powerKW"}
                  minValue={product.powerKWOffset.min}
                  maxValue={product.powerKWOffset.max}
                  showMin={true}
                  showMax={true}
                />
                {/* <WarningAlert
                  value={product.kwh[product.kwh.length - 1]}
                  title={"kwh"}
                  minValue={product.kwhOffset.min}
                  maxValue={product.kwhOffset.max}
                /> */}
              </>
            </div>
          )}
          <br />
          <br />
          <p className="sm:tw-text-3xl tw-text-2xl tw-font-bold tw-text-center">
            Important Parameters
          </p>
          <br />
          <div className="tw-flex tw-flex-row tw-justify-center tw-flex-wrap">
            {product.voltage && product.current && (
              <>
                <CardData
                  title="Battery Voltage"
                  reading={Number(
                    product.batteryVoltage[product.batteryVoltage.length - 1]
                  ).toFixed(1)}
                  unit="V"
                  addUnit="DC"
                  colour="black"
                  bgColour="tw-bg-green-500"
                  icon="fas fa-car-battery"
                />
                <CardData
                  title="Generated Energy"
                  reading={Number(product.kwh[product.kwh.length - 1]).toFixed(
                    1
                  )}
                  unit="KWH"
                  colour="black"
                  bgColour="tw-bg-green-500"
                  icon="fas fa-plug"
                />
                <CardData
                  title="Active Power"
                  reading={Number(
                    product.powerKW[product.powerKW.length - 1]
                  ).toFixed(1)}
                  unit="KW"
                  colour="black"
                  bgColour="tw-bg-green-500"
                  icon="fas fa-plug"
                />
                <CardData
                  title="Power Factor"
                  reading={Number(
                    product.powerFactor[product.powerFactor.length - 1]
                  ).toFixed(1)}
                  unit=""
                  colour="black"
                  bgColour="tw-bg-teal-500"
                  icon="fas fa-plug"
                />
                <CardData
                  title="Max Frequency"
                  reading={Number(
                    product.frequency[product.frequency.length - 1]
                  ).toFixed(1)}
                  unit="Hz"
                  colour="black"
                  bgColour="tw-bg-sky-500"
                  icon="fas fa-wave-square"
                />
              </>
            )}
          </div>
          <br />
          <br />
          <p className="sm:tw-text-3xl tw-text-2xl tw-font-bold tw-text-center">
            Electrical Parameters
          </p>
          <br />
          <div className="tw-flex tw-flex-row tw-justify-center tw-flex-wrap">
            {product.voltage && <>
              <CardData
                title="V-R"
                reading={Number(
                  product.voltage[product.voltage.length - 1].vR
                ).toFixed(1)}
                unit="V"
                addUnit="AC"
                colour="white"
                bgColour="tw-bg-red-500"
                icon="fas fa-bolt"
              />
              <CardData
                title="V-Y"
                reading={Number(
                  product.voltage[product.voltage.length - 1].vY
                ).toFixed(1)}
                unit="V"
                addUnit="AC"
                colour="black"
                bgColour="tw-bg-yellow-400"
                icon="fas fa-bolt"
              />
              <CardData
                title="V-B"
                reading={Number(
                  product.voltage[product.voltage.length - 1].vB
                ).toFixed(1)}
                unit="V"
                addUnit="AC"
                colour="white"
                bgColour="tw-bg-blue-500"
                icon="fas fa-bolt"
              />
            </>}
          </div>
          <div className="tw-flex tw-flex-row tw-justify-center tw-flex-wrap">
            {product.current && (
              <>
                <CardData
                  title="I-R"
                  reading={Number(
                    product.current[product.current.length - 1].iR
                  ).toFixed(1)}
                  unit="A"
                  addUnit="AC"
                  colour="white"
                  bgColour="tw-bg-red-500"
                  icon="fas fa-bolt"
                />
                <CardData
                  title="I-Y"
                  reading={Number(
                    product.current[product.current.length - 1].iY
                  ).toFixed(1)}
                  unit="A"
                  addUnit="AC"
                  colour="black"
                  bgColour="tw-bg-yellow-400"
                  icon="fas fa-bolt"
                />
                <CardData
                  title="I-B"
                  reading={Number(
                    product.current[product.current.length - 1].iB
                  ).toFixed(1)}
                  unit="A"
                  addUnit="AC"
                  colour="white"
                  bgColour="tw-bg-blue-500"
                  icon="fas fa-bolt"
                />
              </>
            )}
          </div>
          <div className="tw-flex tw-flex-row tw-justify-center tw-flex-wrap">
            {product.voltage && product.current && (
              <>
                <CardData
                  title="V-RY"
                  reading={Number(
                    product.voltage[product.voltage.length - 1].vRY
                  ).toFixed(1)}
                  unit="V"
                  addUnit="AC"
                  colour="black"
                  bgColour="tw-bg-teal-500"
                  icon="fas fa-bolt"
                />
                <CardData
                  title="V-YB"
                  reading={Number(
                    product.voltage[product.voltage.length - 1].vYB
                  ).toFixed(1)}
                  unit="V"
                  addUnit="AC"
                  colour="black"
                  bgColour="tw-bg-teal-500"
                  icon="fas fa-bolt"
                />
                <CardData
                  title="V-BR"
                  reading={Number(
                    product.voltage[product.voltage.length - 1].vBR
                  ).toFixed(1)}
                  unit="V"
                  addUnit="AC"
                  colour="black"
                  bgColour="tw-bg-teal-500"
                  icon="fas fa-bolt"
                />
              </>
            )}
          </div>
          <br />
          <br />

          <p className="sm:tw-text-3xl tw-text-2xl tw-font-bold tw-text-center">
            Temperature & Fuel Status
          </p>
          <br />
          <div className="tw-flex tw-justify-around tw-flex-wrap">
            {product.voltage && product.engineCoolantTemp && (
              <>
                {/* <ThermoGuage
                  reading={Number(
                    product.oilTemp[product.oilTemp.length - 1]
                  ).toFixed(1)}
                  title="Oil Temperature"
                  unit="°C"
                /> */}
                <ThermoGuage
                  reading={Number(
                    product.engineCoolantTemp[
                      product.engineCoolantTemp.length - 1
                    ]
                  ).toFixed(1)}
                  title="Coolant Temperature"
                  unit="°C"
                />
                <FuelGuage
                  reading={Number(
                    product.fuelLevel[product.fuelLevel.length - 1]
                  ).toFixed(1)}
                  title="Fuel Level"
                  unit="%"
                />
              </>
            )}
          </div>
          <br />
          <br />
          {/* <p className="sm:tw-text-3xl tw-text-2xl tw-font-bold tw-text-center">
            Speed & Pressure Level
          </p>
          <br />
          <div className="tw-flex tw-justify-around tw-flex-wrap">
            {product.voltage && product.engineCoolantTemp && (
              <>
                <GuageChart
                  rpm={Number(
                    product.engineSpeedRPM[product.engineSpeedRPM.length - 1]
                  )}
                  title="Rotor Speed"
                  unit="RPM"
                />
                <GuageChart
                  reading={Number(
                    product.engineOilPressure[
                      product.engineOilPressure.length - 1
                    ]
                  ).toFixed(1)}
                  title="Oil Pressure"
                  unit="PSi"
                />
              </>
            )}
          </div> */}
          <br />
          <br />
          <p className="sm:tw-text-3xl tw-text-2xl tw-font-bold tw-text-center">
            Last 10 updates Performance
          </p>
          <br />
          <div className="tw-flex tw-justify-around tw-flex-wrap">
            {product.voltage && product.engineCoolantTemp && (
              <>
                <LineChart
                  title="Fuel Level (%)"
                  unit="%"
                  reading={product.fuelLevel}
                  lineColour="#C02323"
                  background="#820401"
                  min={0}
                  max={100}
                  step={10}
                />
                {/* <LineChart
                  title="RPM"
                  unit=""
                  // reading={product.powerKW}
                  reading={product.engineSpeedRPM}
                  lineColour="#176BA0"
                  background="#142459"
                  min={0}
                  max={2000}
                  step={200}
                /> */}
                <LineChart
                  title="PF"
                  unit=""
                  reading={product.powerFactor}
                  lineColour="#7D3AC1"
                  background="#29066B"
                  min={0}
                  max={1}
                  step={0.1}
                />

                {/* <LineChart
                  title="Running Hours"
                  unit="Hours"
                  reading={product.totalRunningHours}
                  lineColour="gray"
                  background="black"
                /> */}
              </>
            )}
          </div>
          <br />
          <br />
          <p className="sm:tw-text-3xl tw-text-2xl tw-font-bold tw-text-center">
            Location
          </p>
          <br />
          <div className="tw-flex tw-justify-around tw-flex-wrap">
            {product.latitude && product.longitude && (
              <MapContainer
                center={{ lat: product.latitude, lng: product.longitude }}
                zoom={10}
                scrollWheelZoom={true}
              >
                <TileLayer
                  attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <Marker
                  position={{ lat: product.latitude, lng: product.longitude }}
                >
                  <Popup minWidth={90}>
                    Genset ID: {product.gensetNumber}
                    <br />
                    Latitude: {product.latitude} <br />
                    Longitude: {product.longitude}
                    <br />
                    <br />
                    <small>Reload the page to center</small>
                  </Popup>
                </Marker>
              </MapContainer>
            )}
          </div>
          <br />
          <br />
          <br />
        </div>
      )}
    </>
  );
};

export default ProductScreen;
